import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import { autobind } from 'core-decorators';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SharePopup from '/@/components/share-popup';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import * as shareAction from '/@/store/private-data/product-datasheet-pdfs/actions';

@connect(null, (dispatch) =>
    bindActionCreators(
        {
            ...shareAction,
        },
        dispatch
    )
)
@autobind
export default class ProductDatasheetShare extends Component {
    state = {
        showPopup: false,
    };

    render() {
        return (
            <Fragment>
                <Button onClick={this.handleShowPopup} variant='contained' startIcon={<ShareIcon fontSize='small' />}>
                    {_('Compartir')}
                </Button>
                <SharePopup
                    visible={this.state.showPopup}
                    title={_('Compartir ficha técnica de producto')}
                    whatsAppIntro={_('Te envío una ficha técnica de producto generada en {{ appName }}', {
                        appName: settings.app.name,
                    })}
                    onClose={this.handleClosePopup}
                    onEmail={this.handleEmail}
                    onWhatsApp={this.handleWhatsApp}
                    onDownload={this.handleDownload}
                />
            </Fragment>
        );
    }

    getPayload() {
        const { productDatasheet, selectedProfiles, country } = this.props;
        return { ...productDatasheet, selectedProfiles: selectedProfiles, country };
    }

    handleShowPopup() {
        this.setState({ showPopup: true });
    }

    handleClosePopup() {
        this.setState({ showPopup: false });
    }

    async handleEmail({ email }) {
        return {
            file: await this.props.emailProductDatasheetPDF({
                productDatasheet: this.getPayload(),
                email,
                productDatasheetConfigs: this.props.productDatasheetConfigs,
            }),
            email,
        };
    }

    async handleWhatsApp() {
        return {
            file: await this.props.downloadProductDatasheetPDF({
                productDatasheet: this.getPayload(),
                productDatasheetConfigs: this.props.productDatasheetConfigs,
            }),
        };
    }

    async handleDownload() {
        return {
            file: await this.props.downloadProductDatasheetPDF({
                productDatasheet: this.getPayload(),
                download: true,
                productDatasheetConfigs: this.props.productDatasheetConfigs,
            }),
        };
    }
}
